import styled from 'styled-components';
import { AllowFullscreenVariableInput } from '../../common/specificPropInputs/variableProps/AllowFullscreenVariableInput';
import { CommandVariableInput } from '../../common/specificPropInputs/variableProps/CommandVariableInput';
import { HrefVariableInput } from '../../common/specificPropInputs/variableProps/HrefVariableInput';
import { SrcVariableInput } from '../../common/specificPropInputs/variableProps/SrcVariableInput';
import { TextVariableInput } from '../../common/specificPropInputs/variableProps/TextVariableInput';
import { VariableTextVariableInput } from '../../common/specificPropInputs/variableProps/VariableTextVariableInput';
import { WindowHandleVariableInput } from '../../common/specificPropInputs/variableProps/WindowHandleVariableInput';
import { TargetVariableInput } from '../../common/specificPropInputs/variableProps/TargetVariableInput';
import { useScene } from '../../../context/sceneContext';

export const VariablePropsPanel = () => {
  const scene = useScene();
  const inputs = scene.getSelectedElementsPropInputs();

  return (
    <Container>
      {inputs.includes('windowHandleVariableInput') && (
        <WindowHandleVariableInput />
      )}
      {inputs.includes('commandVariableInput') && <CommandVariableInput />}
      {inputs.includes('textVariableInput') && <TextVariableInput />}
      {inputs.includes('hrefVariableInput') && <HrefVariableInput />}
      {inputs.includes('variableTextVariableInput') && (
        <VariableTextVariableInput />
      )}
      {inputs.includes('srcVariableInput') && <SrcVariableInput />}
      {inputs.includes('allowFullscreenVariableInput') && (
        <AllowFullscreenVariableInput />
      )}
      {inputs.includes('targetVariableInput') && <TargetVariableInput />}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 5px;
`;
